<template>

  <v-card>

    <v-card-text>
      
      <v-container  class="scrollable">
        
        <p
          v-for="paragraph in paragraphs"
          v-bind:key="paragraph"
        >
          {{paragraph}}
        </p>

      </v-container>
      
    </v-card-text>
    
  </v-card>


</template>

<script>
import textsApi from '@/api/texts.js'

export default {
  name: 'Document',

  data: function() {
    return {
      paragraphs: []
    }
  },

  mounted: function() {
    textsApi.getTextAnd(text => this.paragraphs = text.split('\n'))
  }
  
}

</script>

<style scoped>
.v-card {
  height: 40vh;
}

.scrollable {
  height: 35vh;
  overflow-y: scroll;
}

#header {
  overflow: hidden;
  height: 2vh;
}
</style>
